/*
 * Упоминание «@логин» — одно правило на всё приложение: чат, комментарии,
 * лента задач. То же правило у сервера (server/src/mentions.ts): подсветка,
 * значок «@» и «Вас упомянули» должны соглашаться с тем, кому сервер
 * отправил уведомление.
 *
 * Логин — буквы, цифры, «_» и «-»; точка только между ними («@i.ivanov»).
 * Точка на конце — конец предложения: «Глянь, @ivan.» упоминает ivan.
 */
const LOGIN = '[\\p{L}\\p{N}_-]+(?:\\.[\\p{L}\\p{N}_-]+)*';

/** Упоминание целиком, «@» вместе с логином: для разбора текста на части. */
export const MENTION_TOKEN = `@${LOGIN}`;

const MENTION_RX = new RegExp(`@(${LOGIN})`, 'gu');
const SPLIT_RX = new RegExp(`(${MENTION_TOKEN})`, 'gu');

/**
 * Упомянут ли этот логин целым словом: «@ivanx» — не «@ivan», регистр как в
 * логине.
 */
export function mentionsLogin(text: string, login: string): boolean {
  return [...text.matchAll(MENTION_RX)].some((m) => m[1] === login);
}

/** Текст по частям: упоминания — отдельными кусками, начинаются с «@». */
export function splitMentions(text: string): string[] {
  return text.split(SPLIT_RX);
}
